import { createStrictContext } from 'utils/createContext'
import { IssueTypesContext } from './types'
import { useIssueTypesMetadataQuery, useIssueTypesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<IssueTypesContext>('IssueTypesContext')

export const useIssueTypesContext = useContextFn

const IssueTypesProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useIssueTypesQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { projectId: { equals: projectId } } },
  })
  const metadata = useIssueTypesMetadataQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const dispositionTypes = useOptions({
    items: metadata.data?.project?.issueDispositionTypes,
    value: 'id',
    label: 'name',
    tooltip: 'description',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        loading: loading ?? metadata.loading,
        refetch,
        issueTypes: data?.issueTypes?.records ?? [],
        dispositionTypes,
      }}
    >
      {children}
    </Provider>
  )
}

export default IssueTypesProvider
